module.exports = __webpack_public_path__ + "img/zy2.4791a413.png";